<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Detalhes da Atividade") }}
    </h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="row">
      <div class="col-md-12">
        <print-content>
          <table class="table b-table b-table-stacked-md table-bordered table-sm bg-white">
            <tbody>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ formatDate(item.created_at) }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ formatDate(item.updated_at) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">                                                                        
                  USUÁRIO:
                  <strong> {{ item.acolhimento?.nome_acolhido || '-' }} </strong>
                </td>
                <td>
                  UNIDADE:                                                                          
                  <strong> {{getUnidadeNome(item.acolhimento.unidade_id) }} </strong>
                </td>
                <td>
                  STATUS:
                  <b>{{ item.status }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  ATIVIDADE:
                  <strong> {{ item.atividade }} </strong>
                </td>
                <td>
                  OBJETIVO:
                  <b>{{ item.objetivo }}</b>
                </td>
                <td>
                  LOCAL:
                  <b>{{ item.local }}</b>
                </td>
              </tr>
            </tbody>
          </table>

          <!--<HistoricoStatus
            v-if="item.id"
            :id="item.id"
            :familia="item.familia_id"
            :status="status_item"
            :resposta="true"
          />-->

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <a class="btn btn-default" @click="$router.go(-1)">
                <i class="mdi mdi-arrow-left" />
              </a>

              <a class="btn btn-primary" @click="print()">
                <i class="mdi mdi-printer" />
              </a>
            </div>
          </div>
        </print-content>
      </div>
    </div>
    <!-- <ModalResposta :item="item" @submit="submit" /> -->
  </div>
</template>
<script>

/*
import HistoricoStatus from "./HistoricoStatus";
import ModalResposta from "./includes/ModalResposta";
import Agendamentos from "./includes/SolictacoesAgendamento";
*/

export default {

    /*
  components: {
    ModalResposta,
    Agendamentos,
    HistoricoStatus,
  },

  */
  name: "ShowAtividade",
  data() {
    return {
      item: {},
      unidades: [],
      acolhimento: null,
      loading: true,
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      user_id: null,
      unidade_id: null,
    };
  },

  mounted() {
    this.getItem();
    this.getUnidades();
  },
  methods: {
    formatDate(dateStr) {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        return date.toLocaleDateString('pt-BR');
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/acolhimento/idoso/atividades/imprimir/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data;
          this.loading = false;
        })
        .catch((error) => {
            this.$bvToast.toast('Erro ao buscar os dados da atividade.', {
                title: 'Erro',
                variant: 'danger',
                solid: true
            });
          this.$router.push("/dashboard/acolhimento/gestao-vagas");
        });
    },
    getUnidades() {
      this.loadUnidades = true;
      axios
        .get("api/dashboard/acolhimentos/unidades")
        .then((response) => {
          this.unidades = response.data.data
            .filter((item) => item.unidade)
            .map((item) => ({
              id: item.unidade.id,
              nome: item.unidade.nome,
            }));
        })
        .finally(() => {
          this.loadUnidades = false;
        });
    },
    getUnidadeNome(id) {
      const unidade = this.unidades.find((u) => u.id === id);
      return unidade ? unidade.nome : '-';
    },
    print() {
      const modal = document.getElementById("boxPrint");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
  },
};
</script>

<style>
@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
  }
  #print {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
